import React from 'react';

import WithConfiguration from '@domain/layout/with-configuration';

import { ElearningWpOnSiteFlowProvider } from './ewos-flow-context';

interface ElearningWpOnSiteLayoutProps {
  children: React.ReactNode;
}

function ElearningWpOnSiteLayout({ children }: ElearningWpOnSiteLayoutProps) {
  return (
    <WithConfiguration>
      <ElearningWpOnSiteFlowProvider>{children}</ElearningWpOnSiteFlowProvider>
    </WithConfiguration>
  );
}

export default ElearningWpOnSiteLayout;
